
import { createFileRoute } from "@tanstack/react-router";
import { OrganisationProfileFeature } from "@/features/organisation-profile";

export const Route = createFileRoute("/organisation/")({
    component: OrganisationPage,
    staticData: { authorize: true },
});

function OrganisationPage() {
    return <OrganisationProfileFeature />;
}
